<template>
  <div>
    <b-row
      class="content-header"
    >
      <!-- Content Left -->
      <b-col
        class="content-header-left mb-2"
        cols="12"
        md="9"
      >
        <b-row class="breadcrumbs-top">
          <b-col cols="12">
            <h2 class="content-header-title float-left pr-1 mb-0">
              {{ $t('DEBTIA_VIEW_CASE') }}
            </h2>
            <div class="breadcrumb-wrapper">
              <b-breadcrumb>
                <b-breadcrumb-item to="/cases">
                  <feather-icon
                    icon="HomeIcon"
                    size="16"
                    class="align-text-top"
                  />
                </b-breadcrumb-item>
                <b-breadcrumb-item active>
                  {{ caseID ? caseID : 'N/A' }} (BC-ID: {{ bcCaseId ? bcCaseId : 'N/A' }})
                </b-breadcrumb-item>
              </b-breadcrumb>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow, BCol, BBreadcrumb, BBreadcrumbItem,
} from 'bootstrap-vue'

export default {
  components: {
    BRow,
    BCol,
    BBreadcrumb,
    BBreadcrumbItem,
  },
  props: {
    bcCaseId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      caseID: this.$route.params.id,
    }
  },
}
</script>

<style lang="scss">
</style>
